const FALLBACK_TIMEOUT_MS = 1000;

export const deferUntilNewTitle = (callback: () => void): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const originalTitle = document.title;
  const titleElement = document.querySelector('title');

  if (!titleElement) {
    setTimeout(callback, 0);
    return;
  }

  let hasRun = false;

  const runCallback = () => {
    if (hasRun) {
      return;
    }

    hasRun = true;
    callback();
  };

  const observer = new MutationObserver(() => {
    if (document.title !== originalTitle) {
      observer.disconnect();
      clearTimeout(timeoutId);
      runCallback();
    }
  });

  observer.observe(titleElement, { childList: true, characterData: true, subtree: true });

  const timeoutId = window.setTimeout(() => {
    observer.disconnect();
    runCallback();
  }, FALLBACK_TIMEOUT_MS);
};
